'use client';

import { createContext, useContext, useMemo } from 'react';

type CategoryData = {
  id: number;
  translations: Array<{
    translated_slug: string;
  }>;
  description?: string;
  total_ads_count?: number;
  parent_id?: number;
};

const DataContext = createContext<CategoryData[]>([]);

export function CategoriesDataProvider({ children, initialData }: { children: React.ReactNode; initialData: CategoryData[] }) {
  const value = useMemo(() => initialData, [initialData]);
  
  return (
    <DataContext.Provider value={value}>{children}</DataContext.Provider>
  );
}

export function useCategoriesData(): CategoryData[] {
  return useContext(DataContext);
}
